// Real OFunded brand logo components — theme-aware.
import { useTheme } from "@/contexts/ThemeContext";

export function OFundedLogo({ className = "h-7 w-auto", variant }) {
  // variant override OR auto-detect from theme: dark theme → light logo, light theme → dark logo
  const { theme } = useTheme();
  const auto = theme === "light" ? "dark" : "light";
  const finalVariant = variant || auto;
  const src = finalVariant === "dark" ? "/brand/logo-dark.svg" : "/brand/logo-light.svg";
  return <img src={src} alt="OFunded" className={className} draggable={false} />;
}

export function OFundedIcon({ className = "h-8 w-8", variant = "color" }) {
  const src = variant === "dark" ? "/brand/icon-dark.svg" : "/brand/icon-color.svg";
  return <img src={src} alt="" aria-hidden className={className} draggable={false} />;
}
